// extracted by mini-css-extract-plugin
export default {"form":"FsD2X","inner":"uW9tt","actions":"seNU0","action":"Ea9oq"};